import { REWARDS_SDK_EVENTS } from "./constants";

class RewardsSdkEvents {
    public readonly POPUP_WIDGET_VIEW_CHANGED =
        REWARDS_SDK_EVENTS.popUpWidgetViewChanged;
}

export default RewardsSdkEvents;
